import { IKnmForm } from 'KnmPackage/MainModule/interfaces/IKnmForm';

interface IMarkedField {
  appendShowMarkCondition?: (values: IKnmForm, availableUnplannedActivities: boolean) => boolean;
}

export const isFieldRequiredForNextStatusesInReadyForApprove = (
  fieldName: string | undefined,
  values: IKnmForm,
  availableUnplannedActivities: boolean,
): boolean => {
  if (!fieldName) {
    return false;
  }

  const idRegex = /\[\d+]/gi;
  const fieldNameTemplate = fieldName?.replaceAll(idRegex, '[{id}]');

  if (!fieldNameTemplate || !fieldsRequiredForNextStatusesInReadyForApprove[fieldNameTemplate]) {
    return false;
  }

  const markedField = fieldsRequiredForNextStatusesInReadyForApprove[fieldNameTemplate];

  return (
    !markedField.appendShowMarkCondition || markedField.appendShowMarkCondition(values, availableUnplannedActivities)
  );
};

const fieldsRequiredForNextStatusesInReadyForApprove: Record<string, IMarkedField> = {
  'approvedOnPaperDocuments.attachments': {
    appendShowMarkCondition: values => values.isApprovedOnPaper === true,
  },
};
